<router-outlet></router-outlet>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/app/app.component.html